import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	// ---------- MESSAGE IN ALL ERROR FLAGS -------------
	tryLater: {
		id: 'archive-pages.single-page.flag.failure.try-later',
		defaultMessage: 'Try again later,',
		description:
			'Text in the description for the flag notifying user that the archival request failed to process that is bolded for importance',
	},
	archiveErrorBulkQueueBusy: {
		id: 'archive-pages.archive.error.bulk-queue-busy',
		defaultMessage:
			'Your team is processing a large number of items. <b>Try again later</b>, after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}.',
		description:
			'Error message text when the user tries to either archive a nested content item with children or do a bulk content archive but another bulk operation is already running',
	},
	archiveErrorInvalidContentStatusNotCurrent: {
		id: 'archive-pages.archive.error.invalid-content-status',
		defaultMessage:
			'One or more of the items you have selected can not be archived because it has been deleted, is a draft, or already has been archived.',
		description:
			"Error message text when the user tries to either archive a nested content items with children or do a bulk content archive where one or more items that can't be archived because they have been deleted, are a draft, or has already been archived.",
	},
	archiveErrorLongTaskTimeout: {
		id: 'archive-pages.archive.error.long-task-timeout',
		defaultMessage:
			'Your request is taking longer than expected to process. Please check back soon to see if it completed successfully.',
		description:
			'Error message text when the user tries to either archive a nested content item with children or do a bulk content archive that is taking too long to process.  It will likely succeed, but we will not show anything when it is done.',
	},

	// ---------- ARCHIVE FLAGS -------------

	ARCHIVE_archiveContentFlagSuccess_Title: {
		id: 'archive-pages.single-content.archive.flag.success.title',
		defaultMessage: 'Archived successfully',
		description: 'Title for the flag notifying user that archival processed successfully',
	},

	ARCHIVE_archiveContentFlagSuccess_LinkText: {
		id: 'archive-pages.single-content.archive.flag.success.link-text',
		defaultMessage: 'View in archive',
		description: 'Link text shown on archive success to direct user to view all archived content',
	},

	ARCHIVE_archiveContentFlagFailure_Title: {
		id: 'archive-pages.single-content.archive.flag.failure.title',
		defaultMessage: 'Your archive request had a problem',
		description: 'Title for the flag notifying user that the archival request failed to process',
	},

	ARCHIVE_archiveContentFlagFailure_Body: {
		id: 'archive-pages.single-content.archive.flag.failure.body',
		defaultMessage:
			'Your team is processing a large number of items. {tryLater} after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}.',
		description:
			'Description for the flag notifying user that the archival request failed to process',
	},

	ARCHIVE_archiveContentFlagProgress_Title: {
		id: 'archive-pages.single-content.archive.flag.progress.title',
		defaultMessage: 'Archiving...',
		description: 'Title for the flag notifying user that archival process is in progress',
	},

	ARCHIVE_archiveErrorInvalidPermissions_Body: {
		id: 'archive-pages.archive.error.invalid-perimissions.body',
		defaultMessage:
			'Your archive request has items that you don’t have permission to archive. Please check your selections and try archiving again.',
		description:
			"Error message text when the user tries to either archive a nested content item with children or do a bulk content archive but the user doesn't have permission to archive some of the items.",
	},
	ARCHIVE_archiveErrorInvalidContentIds: {
		id: 'archive-pages.archive.error.invalid-content-ids',
		defaultMessage:
			'Your archive request contains items that don’t seem to exist. Please check your selections and try archiving again. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}.',
		description:
			"Error message text when the user tries to either archive a nested content item with children or do a bulk content archive but the set of items to archive contains items that don't exist, perhaps due to another user archiving them or changing their visibility",
	},

	// ---------- UNARCHIVE FLAGS -------------

	UNARCHIVE_archiveContentFlagSuccess_Title: {
		id: 'archive-pages.single-content.unarchive.flag.success.title',
		defaultMessage: 'Restored successfully',
		description: 'Title for the flag notifying user that restore request processed successfully',
	},

	UNARCHIVE_archiveContentFlagSuccess_LinkText: {
		id: 'archive-pages.single-content.unarchive.flag.success.link-text',
		defaultMessage: 'View',
		description: 'Link to view a restored content after restoration',
	},

	UNARCHIVE_archiveContentFlagFailure_Title: {
		id: 'archive-pages.single-content.unarchive.flag.failure.title',
		defaultMessage: 'Your restore request had a problem',
		description: 'Title for the flag notifying user that the restore request failed to process',
	},

	UNARCHIVE_archiveContentFlagFailure_Body: {
		id: 'archive-pages.single-content.unarchive.flag.failure.body',
		defaultMessage:
			'Your team is processing a large number of items. {tryLater} after the queue has time to clear. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}.',
		description:
			'Description for the flag notifying user that the restore request failed to process',
	},
	UNARCHIVE_archiveContentFlagProgress_Title: {
		id: 'archive-pages.single-content.unarchive.flag.progress.title',
		defaultMessage: 'Restoring...',
		description:
			'Title for the flag notifying the user that the restore request process is in progress',
	},
	UNARCHIVE_archiveErrorInvalidPermissions_Body: {
		id: 'archive-pages.unarchive.error.invalid-perimissions.body',
		defaultMessage:
			'Your restore request has items that you don’t have permission to restore. Please check your selections and try the restore again.',
		description:
			"Error message text when the user tries to either unarchive a nested content item with children or do a bulk content unarchive but the user doesn't have permission to unarchive some of the items.",
	},
	UNARCHIVE_archiveErrorInvalidContentIds: {
		id: 'archive-pages.unarchive.error.invalid-content-ids',
		defaultMessage:
			'Your restore request contains items that don’t seem to exist. Please check your selections and try restoring again. {lineBreak} {lineBreak} If this continues to happen, try contacting {supportLink}.',
		description:
			"Error message text when the user tries to either restore a nested content item with children or do a bulk content restore but the set of items to restore contains items that don't exist, perhaps due to another user restoring them or changing their visibility",
	},

	refresh_LinkText: {
		id: 'archive-pages.bulk-archive.flag.refresh.link-text',
		defaultMessage: 'Refresh',
		description: 'Link to refresh current window to see bulk archive changes.',
	},
});

// Define all the Archive message strings, except the error messages which are defined in the
// "getErrorMessage()" function
export const archiveFlagI18n = {
	successTitle: i18n.ARCHIVE_archiveContentFlagSuccess_Title,
	successLink: i18n.ARCHIVE_archiveContentFlagSuccess_LinkText,
	errorTitle: i18n.ARCHIVE_archiveContentFlagFailure_Title,
	loadingTitle: i18n.ARCHIVE_archiveContentFlagProgress_Title,
};

export const unarchiveFlagI18n = {
	successTitle: i18n.UNARCHIVE_archiveContentFlagSuccess_Title,
	successLink: i18n.UNARCHIVE_archiveContentFlagSuccess_LinkText,
	errorTitle: i18n.UNARCHIVE_archiveContentFlagFailure_Title,
	loadingTitle: i18n.UNARCHIVE_archiveContentFlagProgress_Title,
};
